/**
 * ai.feedback - recursive feedback loop controller
 * helpers: { dispatch, commit, rootState }
 * args: { prompt, goal }
 * For now, repeatedly call callAI until the goal string is found in response or max iterations hit
 */
module.exports = async function feedback(helpers = {}, args = {}) {
  const { dispatch } = helpers
  void dispatch
  const { prompt = '', goal = null, maxIter = 3 } = args
  let last = null
  for (let i=0;i<maxIter;i++) {
    const resp = await dispatch('callAI', { prompt: prompt + `\n\nIteration ${i+1}` })
    last = resp
    if (goal && typeof resp === 'string' && resp.toLowerCase().includes(goal.toLowerCase())) {
      return { done: true, resp }
    }
  }
  return { done: false, resp: last }
}
